// carousel.service.ts
import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CarouselService {
  addItem = new EventEmitter<any>();
  private componetsPopups =new BehaviorSubject<any[]>([])
  eventPopups = this.componetsPopups.asObservable();

  addPopup(componentData : any){
    const current = this.componetsPopups.value;
    this.componetsPopups.next([...current, componentData])
  }

  removePopup(index : number){
    const current = this.componetsPopups.value;
    current.splice(index, 1);
    this.componetsPopups.next([...current]);
  }

  add(component: any, data: any) {
    this.addItem.emit({ component, data });
  }
}
